import app from '@frontastic/catwalk/src/js/app/app';

export const checkUserForRedirect = (loggedIn) => {
  if (loggedIn) return;
  return app.getRouter().history.push('/login-page');
};
